module.exports = __webpack_public_path__ + "static/media/logo_santander.b3be56de.png";